export default __webpack_public_path__ + "static/media/eye.d0a8711f.svg";